<template>
  <div>
    <v-list>
      <v-list-tile @click.stop="navigateTo(defaultCalendarRouteName)">
        <v-list-tile-action>
          <v-icon>calendar_today</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Calendar
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile @click.stop="navigateTo(defaultCalendarRouteName)">
        <v-list-tile-action>
          <v-icon>person</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          Staffing
        </v-list-tile-content>
      </v-list-tile>

      <v-list-group prepend-icon="work" value="true">
        <template slot="activator">
          <v-list-tile>
            <v-list-tile-title>
              HR
            </v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile @click.stop="navigateTo('hr')">
          <v-list-tile-action>
            <v-icon>people_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Employees
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-if="user.clientAdmin"
          @click.stop="navigateTo('clientAdminLocations')"
        >
          <v-list-tile-action>
            <v-icon>domain</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Administered Locations
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click.stop="navigateTo('resources')">
          <v-list-tile-action>
            <v-icon>library_books</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Resources
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click.stop="navigateTo('reports')">
          <v-list-tile-action>
            <v-icon>table_chart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            Reports
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapState('userAuth', ['user', 'token']),
      ...mapGetters('userAuth', ['isLoggedIn', 'defaultCalendarRouteName']),
    },
    methods: {
      logout() {
        this.$store.dispatch('userAuth/logout');
      },
    },
  };
</script>

<style scoped>
  #sidebar a {
    color: black;
    text-decoration: none;
  }
</style>
